"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var S = __importStar(require("fp-ts/string"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var React = __importStar(require("react"));
var __1 = require("..");
var Icon_1 = require("../Icon");
var PickerActivator_1 = require("./PickerActivator");
var datePickerElements_1 = require("./datePickerElements");
require("./datePicker.css");
var buildLabel = function (sDays, selectionType) {
    return (0, function_1.pipe)(O.getMonoid(S.Semigroup).concat((0, function_1.pipe)(sDays.startDate, O.map(function (s) { return (selectionType === 'day' ? s.format('DD MMMM YYYY') : s.format('MMM YYYY')); })), (0, function_1.pipe)(sDays.endDate, O.map(function (s) { return " - ".concat(selectionType === 'day' ? s.format('DD MMMM YYYY') : s.format('MMM YYYY')); }))), O.getOrElse(function () { return (0, moment_timezone_1.default)([]).format('DD MMMM YYYY'); }));
};
var DatePicker = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? {
        contentTheme: 'popover-std',
        disabled: false,
        label: 'Dati relativi a',
        pickerTheme: 'primary',
        pickerType: 'icon',
    } : _b, props = __rest(_a, ["theme"]);
    var _c = React.useState({
        startDate: (0, function_1.pipe)(props.selectionType.startDate, O.map(function (v) { return v.clone(); })),
        endDate: props.selectionType.multipleSelect
            ? (0, function_1.pipe)(props.selectionType.endDate, O.map(function (v) { return v.clone(); }))
            : (0, function_1.pipe)(props.selectionType.startDate, O.map(function (v) { return v.clone(); })),
    }), initPeriod = _c[0], setInitPeriod = _c[1];
    var _d = React.useState({
        startDate: initPeriod.startDate,
        endDate: initPeriod.endDate,
        viewDate: (0, function_1.pipe)(props.selectionType.startDate, O.map(function (v) { return v.clone(); }), O.getOrElse(function () { return (0, moment_timezone_1.default)([]); })),
        open: false,
    }), state = _d[0], setState = _d[1];
    var _e = React.useState(false), isBoundError = _e[0], setBoundError = _e[1];
    React.useEffect(function () {
        (0, function_1.pipe)(props.selectionType.startDate, O.filter(function (st) { return st.isValid(); }), O.map(function (startDate) {
            setState({
                startDate: O.some(startDate.clone()),
                endDate: props.selectionType.multipleSelect
                    ? (0, function_1.pipe)(state.endDate, O.map(function (v) { return v.clone(); }))
                    : O.some(startDate.clone()),
                viewDate: startDate.clone(),
                open: false,
            });
            setInitPeriod({
                startDate: O.some(startDate.clone()),
                endDate: props.selectionType.multipleSelect
                    ? (0, function_1.pipe)(state.endDate, O.map(function (v) { return v.clone(); }))
                    : O.some(startDate.clone()),
            });
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.selectionType.startDate.toString()]);
    var handleClick = function (date) {
        if (!props.selectionType.multipleSelect) {
            setState({
                startDate: O.some(date),
                endDate: O.some(date),
                viewDate: date,
                open: false,
            });
            return props.selectionType.onChange && props.selectionType.onChange(date);
        }
        var start = (0, function_1.pipe)(state.startDate, O.toNullable);
        var isBoundErrorP = false;
        if (props.selectionType.maxRange &&
            start !== null &&
            date.isAfter(start.clone().add(props.selectionType.maxRange.amount, props.selectionType.maxRange.unit)) &&
            (0, function_1.pipe)(state.endDate, O.isNone)) {
            isBoundErrorP = true;
        }
        if (start === null || start.isAfter(date) || (0, function_1.pipe)(state.endDate, O.isSome)) {
            setState({
                startDate: O.some(date),
                endDate: O.none,
                viewDate: date,
                open: true,
            });
            setBoundError(isBoundErrorP);
            if (theme.contentTheme === 'inPage' && !isBoundErrorP) {
                return props.selectionType.onChange && props.selectionType.onChange(date, date);
            }
            return;
        }
        setState({
            startDate: state.startDate,
            endDate: O.some(date),
            viewDate: date,
            open: theme.contentTheme !== 'inPage',
        });
        setBoundError(isBoundErrorP);
        if (theme.contentTheme === 'inPage' && !isBoundErrorP) {
            return props.selectionType.onChange && props.selectionType.onChange(start, date);
        }
        return;
    };
    var renderCalendar = function () {
        var _a, _b;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('calendar-area', theme.contentTheme === 'popover-sm' ? 'font-size-sm' : 'font-size-std') }, { children: (0, datePickerElements_1.renderDays)(props.selectionType.pickerType, state, setState, handleClick, props.selectionType.lowerBound, props.selectionType.upperBound) })), props.selectionType.multipleSelect && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "calendar-footer-text" }, { children: (0, jsx_runtime_1.jsxs)(__1.FlexView, __assign({ hAlignContent: "center", vAlignContent: "center", gutters: { t: 'std' }, flowDirection: { xs: 'column' } }, { children: [(0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "calendar-footer-text-info" }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { size: "xl", icon: "icon_info_light" }), (0, jsx_runtime_1.jsx)("span", { children: props.footerLabel || 'Clicca due date per selezionare un periodo' })] })) })), isBoundError && ((0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "calendar-footer-bound-error" }, { children: (0, jsx_runtime_1.jsx)("span", { children: (_b = (_a = props.selectionType.maxRange) === null || _a === void 0 ? void 0 : _a.warningMessage) !== null && _b !== void 0 ? _b : 'Attenzione hai selezionato un periodo troppo lungo' }) })) }))), theme.contentTheme !== 'inPage' && ((0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xs: 5 }, { children: (0, jsx_runtime_1.jsx)(__1.Button, __assign({ type: "button", styleType: "ghost", stretch: true, onClick: function () {
                                            var start = (0, function_1.pipe)(state.startDate, O.toNullable);
                                            var end = (0, function_1.pipe)(state.endDate, O.toNullable);
                                            if (props.selectionType.onChange && start !== null) {
                                                end === null
                                                    ? props.selectionType.onChange(start, start)
                                                    : props.selectionType.onChange(start, end);
                                                setState(__assign(__assign({}, state), { open: !state.open }));
                                                setInitPeriod({
                                                    startDate: state.startDate,
                                                    endDate: end === null ? state.startDate : state.endDate,
                                                });
                                            }
                                        }, disabled: (0, function_1.pipe)(state.startDate, O.isNone) || isBoundError }, { children: "Applica" })) })))] })) })) }))] }));
    };
    switch (theme.contentTheme) {
        case 'popover-sm':
        case 'popover-std': {
            var onClickActivator = function () {
                if (state.open && props.selectionType.multipleSelect) {
                    setState(__assign(__assign({}, state), { startDate: initPeriod.startDate, endDate: initPeriod.endDate, open: !state.open }));
                    return;
                }
                setState(__assign(__assign({}, state), { open: !state.open }));
            };
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "date-picker-popover" }, { children: (0, jsx_runtime_1.jsxs)(__1.Popover, __assign({ open: state.open, onClickOutside: onClickActivator, appendClickListenerToElementRef: props.appendClickListenerToElementRef }, { children: [(0, jsx_runtime_1.jsx)(PickerActivator_1.PickerActivator, { disabled: theme.disabled, icon: "icon_calendar_light", label: theme.label, labelPicked: buildLabel(state, props.selectionType.pickerType), onClick: onClickActivator, type: theme.pickerType, theme: theme.pickerTheme, onFocus: props.onFocus }), (0, jsx_runtime_1.jsx)(__1.ContentPopover, __assign({ theme: "simple" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "date-picker" }, { children: renderCalendar() })) }))] })) })));
        }
        case 'inPage': {
            return (0, jsx_runtime_1.jsx)("div", __assign({ className: "date-picker date-picker-in-page" }, { children: renderCalendar() }));
        }
    }
};
exports.DatePicker = DatePicker;
exports.DatePicker.defaultProps = {
    theme: {
        contentTheme: 'popover-std',
        disabled: false,
        label: 'Dati relativi a',
        pickerTheme: 'primary',
        pickerType: 'icon',
    },
};
//# sourceMappingURL=DatePicker.js.map